import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SubHeader from '../../Header/SubHeader';
import SearchTab from './components/searchTab/SearchTab';
import CreateTab from './components/createTab/CreateTab';
import UserRoles from '../../../constants/userRoles';
import { accessDeniedDefault, missingModulePermission } from '../../../constants/accessDeniedMessages';

const menuOptionsLabels = {
  Search: 'Search',
  Create: 'Create'
}

const RulesConfiguration = () => {
const [menuOptions, setMenuOptions] = useState([
    {
      index: 0,
      label: menuOptionsLabels.Search,
    },
    {
      index: 1,
      label: menuOptionsLabels.Create,
    },
  ]);
  const navigate = useNavigate();
  const [accessDenied, setAccessDenied] = useState({ status: false, message: null });
  const user = useSelector((state) => state.User);
  const [selectedOptionMenu, setSelectedOptionMenu] = useState(menuOptionsLabels.Search);
  const [ruleToEdit, setRuleToEdit] = useState();
  const [ruleResponse, setRuleResponse] = useState('')

  const handleSelected = (choise, response=null) => {
    if (response) setRuleResponse(response);

    setSelectedOptionMenu(choise.label);
  };
  const handleEditRule = (elem) => {
    setRuleToEdit(elem);
    setSelectedOptionMenu(menuOptionsLabels.Create);
  };

  const cleanUp = () => {
    setRuleToEdit(null);
    setRuleResponse('');
  }

  useEffect(() => {
    if (user) {
      console.log('RulesConfiguration.jsx: Current User Role:', user.Role);
      if (user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner && user.Role !== UserRoles.WFM) {
        console.log('RulesConfiguration.jsx: User does not have Admin access and Owner access and WFM access.');
        setAccessDenied({ status: true, message: accessDeniedDefault });
      }
      else {
        // (1) If Search is disabled
        if (!(user.Claims.RulesConfigurationEnterpriseSearch) 
          && !(user.Claims.RulesConfigurationCustomSearch) && user.Role !== UserRoles.Admin
          && user.Role !== UserRoles.Owner
        ) {
          // (1.1) Then if Create is enabled
          if (user.Claims.RulesConfigurationEnterpriseCreate
            || user.Claims.RulesConfigurationCustomCreate
          ) {
            // Remove Search and set Create as default
            setMenuOptions(menuOptions.filter(option => option.label !== menuOptionsLabels.Search));
            setSelectedOptionMenu(menuOptionsLabels.Create);
          }
          else if (
            !(user.Claims.RulesConfigurationEnterpriseCreate) 
            && !(user.Claims.RulesConfigurationCustomCreate)
          ) {
            setAccessDenied({ status: true, message: missingModulePermission });
          }
        }
  
        // (2) If Create is disabled
        if (!(user.Claims.RulesConfigurationEnterpriseCreate)
          && !(user.Claims.RulesConfigurationCustomCreate) && user.Role !== UserRoles.Admin
          && user.Role !== UserRoles.Owner
        ) {
          // (2.1) Then if Edit is enabled
          if (user.Claims.RulesConfigurationEnterpriseEdit
            || user.Claims.RulesConfigurationCustomEdit
          ) {
            // Add property 'isDisabled' to Create
            setMenuOptions(
              [
                ...menuOptions.filter(options => options.label !== menuOptionsLabels.Create),
                {
                  ...menuOptions.find(options => options.label === menuOptionsLabels.Create),
                  isDisabled: true
                }
              ]
            );
          }
          // (2.2) Else, if Edit is disabled
          else if (!(user.Claims.RulesConfigurationEnterpriseEdit)
            && !(user.Claims.RulesConfigurationCustomEdit)
          ) {
            // Remove Create from menu options
            setMenuOptions(menuOptions.filter(option => option.label !== menuOptionsLabels.Create));
          }
        }
      }
    }
  }, [user]);

  return (
    (() => {
      if (accessDenied.status) {
        return navigate(
          { pathname: '/AccessDenied', state: { message: accessDenied.message } }
        );//        return <Redirect to={{ pathname: '/AccessDenied', state: { message: accessDenied.message } }} />; 
      }

      if (menuOptions.length) {
        return (
          <>
            <SubHeader
              handleSelected={handleSelected}
              options={menuOptions}
              selectedOptions={selectedOptionMenu}
            />
              {
                selectedOptionMenu === menuOptionsLabels.Search ?
                <SearchTab handleEditRule={handleEditRule} ruleResponse={ruleResponse} /> :
                <CreateTab ruleToEdit={ruleToEdit} cleanUp={cleanUp} handleSelected={handleSelected} />
              }
          </>
        );
      }

      return null;
    })()
  );
};

RulesConfiguration.prototype = {
  selectedOptionMenu: PropTypes.array.isRequired,
  handleSelected: PropTypes.func.isRequired,
  handleEditRule: PropTypes.func,
};

export default RulesConfiguration;
